import { Directive, ViewChild } from '@angular/core';
import { DocumentService } from 'src/app/_services/document.service';
import { ProposalService } from 'src/app/_services/proposal.service';
import { ValuableObjectsInsuranceMetatadata } from 'src/app/_types/lead.types';
import {
  getValuableObjectInsuranceTypeLabel,
  getValuableObjectTypeLabel,
} from 'src/app/enums/valuable-object.enum';
import { getBooleanLabel } from 'src/app/helpers/utils';

import { PdfViewerModalComponent } from '../../../pdf-viewer-modal/pdf-viewer-modal.component';
import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export abstract class ValuableObjectsMetadataComponentAbstract extends BaseMetadataComponent<ValuableObjectsInsuranceMetatadata> {
  getValuableObjectTypeLabel = getValuableObjectTypeLabel;

  getValuableObjectInsuranceTypeLabel = getValuableObjectInsuranceTypeLabel;

  getBooleanLabel = getBooleanLabel;

  @ViewChild('pdfViewer') viewer!: PdfViewerModalComponent;

  constructor(
    proposalService: ProposalService,
    private readonly documentService: DocumentService
  ) {
    super(proposalService);
  }

  viewFile(key: string) {
    this.documentService.getPresignedUrl(key).subscribe((res) => {
      if (res.status === 'SUCCESS') {
        this.viewer.pdfFileUrl = res.data.preSignedUrl;
        this.viewer.openModal();
      }
    });
  }
}
